import React from 'react';
import TumbNail from '../event/thumb_nail';

const SearchEventBoxVertical = ({
  eventItem,
  currentUser,
  hashedCompanyId = null,
  isFollowed = false,
}) => {
  const adParam = eventItem.hashed_event_pr_allocation_id
    ? `event_pr_allocation=${eventItem.hashed_event_pr_allocation_id}`
    : eventItem.hashed_circles_ad_id
      ? `circles_ad=${eventItem.hashed_circles_ad_id}`
      : null;
  let eventUrl = eventItem.ad_type && adParam
    ? '/circle/' +
      eventItem.circle.id +
      '/events/' +
      eventItem.id +
      `?${adParam}`
    : '/circle/' + eventItem.circle.id + '/events/' + eventItem.id;
  eventUrl = hashedCompanyId
    ? '/community/' + hashedCompanyId + eventUrl
    : eventUrl;

  // 「会っています」ピルの名前表示。CSSのtext-overflow:ellipsisに任せると、同じ行の
  // 末尾テキスト「さんと前に会っています」がflexboxの仕様上その全文幅を最小幅として
  // 確保してしまい、名前に使える幅が圧迫された上にellipsisの切り詰め計算が幅ぴったり
  // に一致せず、見た目に不自然な余白が残ることがあった。文字数を固定で切り詰める。
  // 4文字以下はそのまま表示、5文字以上は先頭3文字+「…」にする。
  const MET_FRIEND_NAME_FULL_DISPLAY_MAX_LENGTH = 4;
  const MET_FRIEND_NAME_TRUNCATED_LENGTH = 3;
  const metFriendName = eventItem.met_friend
    ? eventItem.met_friend.name.length <= MET_FRIEND_NAME_FULL_DISPLAY_MAX_LENGTH
      ? eventItem.met_friend.name
      : `${eventItem.met_friend.name.slice(0, MET_FRIEND_NAME_TRUNCATED_LENGTH)}…`
    : '';

  // アバターは負のmargin-rightで少し重ねて表示しているため、後ろ側（配列の後の方）が
  // 手前に来る。主催者の「主催」バッジが後続のアバターに隠れないよう、主催者を先頭に
  // 並び替えた上で、先頭ほど手前に来るようzIndexを逆順に振る。
  const sortedParticipants = eventItem.valid_events_plans_users
    ? [...eventItem.valid_events_plans_users]
        .sort((a, b) => (a.participant_type === 1 ? 0 : 1) - (b.participant_type === 1 ? 0 : 1))
        .slice(0, 10)
    : [];

  return (
    <React.Fragment>
      <div
        key={eventItem.id}
        className="col-6 col-sm-6 col-md-4 col-lg-3 event-card-col-2026 p-0 px-1 mb-2"
        data-event-id={eventItem.id}
      >
        <div className="container h-100 event-flame event-card-2026">
          <a href={eventUrl} className="hov--default">
            <div className="event-image-inset-2026">
              <div className="adjust-box adjust-box-16x9 row">
              <TumbNail eventItem={eventItem}/>
              {eventItem.is_full ? (
                <span className="event-status-badge-2026 event-status-badge-full-2026">
                  満席
                </span>
              ) : eventItem.is_application_ended ? (
                <span className="event-status-badge-2026 event-status-badge-ended-2026">
                  募集終了
                </span>
              ) : (
                ''
              )}
              {currentUser && currentUser.id ? (
                <button
                  className="btn-follow event-list-follow-chip position-absolute"
                  data-event_id={eventItem.id}
                  data-circle_id={eventItem.circle.id}
                  data-followed={isFollowed ? 'true' : 'false'}
                  aria-label={isFollowed ? '気になるを解除する' : '気になるに追加する'}
                >
                  <img
                    src={
                      isFollowed
                        ? '/assets2019/img/favorite_black_24dp.svg'
                        : '/assets2019/img/favorite_border_black_24dp.svg'
                    }
                    alt=""
                  />
                </button>
              ) : (
                ''
              )}

              </div>
            </div>

            <div className="container p-0 event-content-px-2026 pt-1">
              <div className="event-datetime-place-row-2026">
                <span className="event-datetime-text-2026">
                  {eventItem.event_month_only}/{eventItem.event_date_only}({eventItem.event_date_weekday_kanji}) {eventItem.event_time_only}〜
                </span>
                <span className="event-datetime-place-separator-2026" aria-hidden="true">｜</span>
                <span className="event-place-text-2026">
                  <span className="event-place-pin-2026" aria-hidden="true">
                    <i className="fas fa-map-marker-alt"></i>
                  </span>
                  <span className="event-place-name-2026">
                    {eventItem.is_online
                      ? 'オンライン'
                      : eventItem.countries_pref
                        ? eventItem.countries_pref.name == '北海道'
                          ? eventItem.countries_pref.name
                          : eventItem.countries_pref.name.slice(0, -1)
                        : '全国'}
                    {eventItem.place ? `・${eventItem.place}` : ''}
                  </span>
                </span>
              </div>

              <div className="px-0 event-title-field">
                <p
                  className={`mt-1 mb-1 line-2 event-title-text-2026 ${
                    eventItem.circle.is_company_owned
                      ? 'icon-tunagate_official_sm_before'
                      : ''
                  }`}
                >
                  {eventItem.title}
                </p>
              </div>

              <div className="w-100 event-icon-field">
                      <div className="event-name-avatars-row-2026">
                        <div className="event-ciecle-field">
                          {eventItem.ad_type ? (
                            <p className="mb-1 event-circle-text-fade-2026 event-circle-text text-gray">
                              {eventItem.ad_type && '[PR] '}
                              {eventItem.circle.name}
                            </p>
                          ) : (
                            <p className="mb-1 event-circle-text-fade-2026 event-circle-text text-gray">
                              {eventItem.circle.name}
                            </p>
                          )}
                        </div>
                        <ul className="d-flex align-items-end list-unstyled overflow-x-hidden-list event-avatar-list-fade-2026 mt-1 mb-0">
                          {sortedParticipants.map(function (events_plans_user, index) {
                                return (
                                  events_plans_user.user && (
                                    <li
                                      key={events_plans_user.id}
                                      className="position-relative"
                                      style={{ zIndex: sortedParticipants.length - index }}
                                    >
                                      <img
                                        className="member-icon-xxs lazyloaded"
                                        src={`${events_plans_user.user.avatar_thumb}`}
                                      />
                                      {events_plans_user.participant_type === 1 ? (
                                        <span className="event-organizer-chip-2026">主催</span>
                                      ) : (
                                        ''
                                      )}
                                    </li>
                                  )
                                );
                              })}
                          {eventItem.valid_events_follows &&
                            eventItem.valid_events_follows
                              .slice(0, 10 - eventItem.num_of_participants)
                              .map(function (events_follow) {
                                return (
                                  <li key={events_follow.id}>
                                    <img
                                      className="member-icon-xxs lazyloaded"
                                      src={`${
                                        events_follow.user &&
                                        events_follow.user.avatar_thumb
                                      }`}
                                    />
                                  </li>
                                );
                              })}
                        </ul>
                      </div>

                      <div className="event-campaign-field">
                        {eventItem.max_point > 0 && (
                          <p className="text-black mt-1 mb-1 event-campaign-text">
                            最大
                            <span className="text-orange event-campaign-text text-fw-bold">
                              {eventItem.max_point}pt
                            </span>
                            もらえる！
                          </p>
                        )}
                      </div>

                      {eventItem.met_friend ? (
                        <div className="event-met-friend-pill-2026">
                          <span className="event-met-friend-pill-icon-2026" aria-hidden="true">✓</span>
                          <span className="event-met-friend-pill-name-2026">{metFriendName}</span>
                          {'さんと前に会っています'}
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
            </div>
          </a>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchEventBoxVertical;